import React, { Component } from 'react';
import styled from 'styled-components';
import nl2br from 'react-nl2br';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';

const Container = styled.div`
  padding-top: 3rem;
  padding-bottom: 1rem;
`;

const Title = styled.h2`
  text-align: center;
  margin-bottom: 2rem;
  font-size: 2rem;
  background-color: #fa5856;
  padding: 1rem;
  color: #fff;
  font-size: 2.5rem;
`;

const SubTitle = styled.h5`
  font-size: 1.25rem;
  text-align: center;
  margin-bottom: 1.5rem;
`;

const Description = styled.p`
  text-align: center;
  margin-bottom: 2rem;
`;

class About extends Component {
  static propTypes = {
    intl: intlShape.isRequired,
  }

  render() {
    const { intl } = this.props;

    return (
      <Container className="container">
        <div className="row">
          <div className="col-md-8 offset-md-2">
            <Title>
              <span style={{ fontSize: '2rem' }}>
                {nl2br(intl.formatMessage({
                  'id': 'About.Title',
                }))}
              </span>
              <br />
              {nl2br(intl.formatMessage({
                'id': 'About.TitleSub',
              }))}
            </Title>
            <Description>
              <FormattedMessage id="About.SubTitle" />
            </Description>
            <ul className="d-flex flex-column justify-content-center align-items-center">
              <li>
                <FormattedMessage id="About.List.1" />
              </li>
              <li>
                <FormattedMessage id="About.List.2" />
              </li>
              <li>
                <FormattedMessage id="About.List.3" />
              </li>
            </ul>
            <Description>
              {nl2br(intl.formatMessage({
                'id': 'About.Description',
              }))}
            </Description>
            <SubTitle style={{ marginBottom: '0.5rem' }}>
              <FormattedMessage id="About.DescriptionTitle3" />
            </SubTitle>
            <SubTitle>
              {nl2br(intl.formatMessage({
                'id': 'About.Description3.Title',
              }))}
            </SubTitle>
            <Description>
              {nl2br(intl.formatMessage({
                'id': 'About.Description3',
              }))}
            </Description>
            <SubTitle>
              {nl2br(intl.formatMessage({
                'id': 'About.Description4.Title',
              }))}
            </SubTitle>
            <Description>
              {nl2br(intl.formatMessage({
                'id': 'About.Description4',
              }))}
            </Description>
          </div>
        </div>
      </Container>
    );
  }
}

export default injectIntl(About);
